import { render, staticRenderFns } from "./ClassRoomDetails.vue?vue&type=template&id=3cd4cc40&"
import script from "./ClassRoomDetails.vue?vue&type=script&lang=js&"
export * from "./ClassRoomDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClassRoomDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClassRoomDetails.vue"
export default component.exports